import React, { useEffect, useRef, useState } from "react";

import { delete_icon, okiee } from "../../assets/img";

import DateRange2 from "../../Component/DateRange/DateRange2";
import { CustomTable } from "../../Component/CustomTable";
import { deletes, get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import moment from "moment";
import CustomScroll from "../../Component/CustomScroll";
import { useLocation } from "react-router-dom";

const RechargeHistory = () => {

  const { kv, set } = useStoreKv();
  const Recharge = kv.recharge || [];

  const [loader, setLoader] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [search, setSearch] = useState('');

  const [popup, setPopup] = useState(false);
  const [popup2, setPopup2] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [block_reason, setBlock_reason] = useState('');
  const [owners, setOwners] = useState(Recharge);
  const [idd, setIdd] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [pendingList, setPendingList] = useState(false);
  const [totalRecharge, setTotalRecharge] = useState(0);
  const [loadingId, setLoadingId] = useState(null);
  const lastRequestId = useRef(0);
  const [isApprove, setIsApprove] = useState(null);
  const [showMessage, setShowMessage] = useState('');
  const [pendingLoad, setPendingLoad] = useState(false);
  const [searchLoad, setSearchLoad] = useState(false);
  const [hiddenIds, setHiddenIds] = useState([]);

  const location = useLocation();
  const scrollRef = useRef(null);

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 0);
        getList();
      }
    }
  }, [location]);


  const getList = async (page = 1, filters = [], currentRequestId) => {
    if (!kv.recharge || kv.recharge.length === 0) {
      setLoading(true);
    }

    let pending;
    if (pendingList) {
      pending = `status=1`
    } else {
      pending = `status=`
    }

    try {
      const query = filters.length ? `&${filters.join("&")}` : "";
      const res = await get(`${URLS.CLIENT}/wallet/recharges?page=${page}${query}&${pending}`);

      if (currentRequestId !== lastRequestId.current) return;

//       console.log("res client list", res);

      if (res?.status === "success") {
        setTotalRecharge(res?.totalrechargeamount)
        setOwners(res?.data || []);
        set('recharge', res?.data || []);
        // setTotalUser(res?.pagination?.total_count);
        setPagination(res?.pagination?.total_pages);
        setLoading(false)
      } else {
        setOwners([]);
        setLoading(false);
        setSearchLoad(false);
        set('recharge', []);
      }
    } catch (error) {
      if (currentRequestId !== lastRequestId.current) return;
      console.error("Error fetching client list:", error);
      setLoading(false)
      setOwners([]);
    }
  };

  useEffect(() => {
    const currentRequestId = ++lastRequestId.current;

    let filters = [];
    if (search) filters.push(`mobile=${encodeURIComponent(search)}`);
    if (selectedDate)
      filters.push(`date=${encodeURIComponent(selectedDate)}`);

    getList(page, filters, currentRequestId);
  }, [selectedDate, search, page, pendingList]);


  const handleApprove = async (id) => {

    setLoadingId(id);
    setHiddenIds(prev => [...prev, id]);
    let filters = [];
    const currentRequestId = ++lastRequestId.current;
    if (id) {
      try {
        const res = await post(`${URLS.CLIENT}/wallet/recharges/approve/${id}`);
//         console.log("res", res);
        if (res?.status === "success") {
          getList(page, filters, currentRequestId);
          // setLoadingId(null);
          Toast(res.message || 'Response successfully');
        }
      } catch (err) {
//         console.log("err", err);
      }
    }
  };

  // const handleReject = async (id) => {
  //   let filters = [];
  //   const currentRequestId = ++lastRequestId.current;
  //   if (id) {
  //     try {
  //       const res = await post(`${URLS.CLIENT}/wallet/recharges/reject/${idd}`);
  //       console.log("res", res);
  //       if (res?.status === "success") {
  //         getList(page, filters, currentRequestId);
  //         Toast(res.message || 'Response successfully');
  //       }
  //     } catch (err) {
  //       console.log("err", err);
  //     }
  //   }
  // };

  const handleBlock = async (status) => {

    let filters = [];
    const currentRequestId = ++lastRequestId.current;

    const payload = {
      block_reason: block_reason,
    };

    try {
      setLoader(true);

      // const changeStatus = status === 'Blocked' ? 'block' : 'unblock';
      const res = await post(`${URLS.CLIENT}/${idd}/block`, payload);

//       console.log("Block/unblock success:", res);

      if (res?.status === "success") {
        if (status === 'Blocked') {
          setPopup(false);
        }
        getList(page, filters, currentRequestId);
      } else {
        console.error("Failed to change block status:", res);
      }
    } catch (err) {
      console.error("Error during block/unblock:", err);
    } finally {
      setLoader(false);
    }
  };

//   console.log("isApprove", isApprove);

  const handleDelete = async () => {
    const filters = [];
    const currentRequestId = ++lastRequestId.current;

    if (!idd) return;

    setLoading1(true);

    try {


      // 👉 2) IF reject is required
      if (isApprove === "No") {
        const rejectRes = await post(`${URLS.CLIENT}/wallet/recharges/reject/${idd}`);
//         console.log("rejectRes", rejectRes);

        if (rejectRes?.status === "success") {
          Toast(rejectRes.message || "Rejected successfully");
        }
      }


      // 👉 1) DELETE API call
      const deleteRes = await deletes(`${URLS.CLIENT}/wallet/recharges/delete/${idd}`);
//       console.log("deleteRes", deleteRes);

      if (deleteRes?.status === "success") {
        Toast(deleteRes.message || "Deleted successfully");
        setDeletePopup(false);
      } else {
        // If delete fails, stop further action
        setDeletePopup(false);
        return;
      }



      // 👉 3) Refresh List
      getList(page, filters, currentRequestId);

    } catch (err) {
//       console.log("err", err);
      setDeletePopup(false);

    } finally {
      setLoading1(false);
    }
  };


  const handleSearch = () => {
    if (!mobile) return;
    setSearchLoad(true);
    setLoading(true);
    setSearch(mobile);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: (
          <span>
            Request
            <br />
            Date & Time
          </span>
        ),
        accessor: "date",
        Cell: ({ row }) => {
          const { date, time } = row.original;
          return (
            <div style={{ textAlign: "center" }}>
              <p className="mt-0" >{date || '-'}</p>
              <p style={{ textAlign: "center" }} className="mt-0">{time || '-'}</p>
            </div>
          );
        },
      },
      {
        Header: (
          <span>
            Approved
            <br />
            Date & Time
          </span>
        ),
        accessor: "time",
        Cell: ({ row }) => {
          const { updated_date, updated_time, approved } = row.original;
          return (
            <div style={{ textAlign: "center" }}>
              <p className="mt-0" >{approved === 'Yes' ? updated_date : '-'}</p>
              <p className="mt-0">{approved === 'Yes' ? updated_time : '-'}</p>
            </div>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">₹&nbsp;{value}</p>;
        },
      },
      {
        Header: "Transaction Id",
        accessor: "transaction_id",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => {
          const isApproved = row.original.approved === "No";


          return (
            <div style={{ width: 100 }} className="d-flex ac-jc gap-3">
              {isApproved &&
                !hiddenIds.includes(row.original?.id) && (
                  <button
                    onClick={() => handleApprove(row.original?.id)}
                    className="cust-btn"

                  >
                    <img src={okiee} alt="approved" className="okiee-btn" />
                  </button>
                )}


              {/* {isApproved && (
                <button onClick={() => handleReject(row.original?.id)} className="cust-btn">
                  <img src={thumdown} alt="approved" className="okiee-btn" />
                </button>
              )} */}

              <button onClick={() => {
                setIdd(row.original?.id);
                setDeletePopup(true);
                setIsApprove(row.original.approved);
              }} className="cust-btn">
                <img src={delete_icon} alt="delete" className="delete-icon" />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Balance",
        accessor: "balance",
        Cell: ({ value, row }) => {
          return <p>₹&nbsp;{value}</p>;
        },
      },
      {
        Header: "Approved",
        accessor: "approved",
        Cell: ({ value, row }) => {
          return (
            <button onClick={() => {
              setShowMessage(row?.original?.approved_by);
              setPopup2(true);
            }} className="cust-btn">
              <p style={{ color: 'white' }}>{value}</p>
            </button>
          )
        },
      },
      // {
      //   Header: "Approved By",
      //   accessor: "approved_by",
      //   Cell: ({ value, row }) => {
      //     return <p>{value || '_'}</p>;
      //   },
      // },


      {
        Header: "User Block",
        accessor: "userblock",
        Cell: ({ row }) => {
          return (
            <div className="d-flex ac-jc">
              <button
                onClick={() => {
                  if (row.original?.client_status !== 'Blocked') {
                    setPopup(true);
                    setIdd(row.original?.client_id);
                  }
                }}
                style={{ backgroundColor: row.original?.client_status !== 'Blocked' ? '#004743' : 'black', color: 'white', borderRadius: 10, fontSize: 12 }}
                className=".block_icon border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
              >
                {row.original?.client_status == 'Blocked' ? 'Blocked' : 'Block'}
              </button>
            </div>
          );
        },
      },
    ],
    [loadingId]
  );

  const [browsHeader, setBrowsHeader] = useState(true);

  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;

      // 🔹 Skip logic on first run
      if (isFirstRun.current) {
        isFirstRun.current = false;
        setBrowsHeader(true);
        return;
      }

      // 🔻 Viewport reduced (keyboard / browser UI)
      if (visibleHeight < maxHeight.current) {
        setBrowsHeader(true);

      }
      // 🔺 Viewport restored
      else {
        maxHeight.current = visibleHeight;
        setBrowsHeader(false);
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [browsHeader]);

  return (
    <div style={{
      paddingBottom: 52
    }} className="dashRightView marginScrollz d-flex ac-jb flex-column">
      <CustomScroll ref={scrollRef} height="100vh">
        <div className="container_overalls"
          style={{
            paddingBottom: 100
          }}>
          <div className="col-md-5 d-flxChanges d-flex ae-jc recharge_container w-100 gap-3 ">
            <button style={{ minHeight: 50 }} onClick={() => {
              setPendingList(!pendingList);
              setPendingLoad(true);
              setLoading(true);
            }} className="recharge_button  white w-50 f1 fs-xs-14 fs-sm-10 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14">
              {(loading && pendingLoad) ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                />
              ) : (
                <>
                  Recharge <br />
                  Pending List
                </>
              )}
            </button>
            <div className="w-50 col-md-5">
              <p className="f2 my-1 pt-3  fs-xs-14 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-16 text-center  sec">
                {`${selectedDate ? (moment(selectedDate).isSame(moment(), 'day') ? 'Today' : moment(selectedDate).format("DD-MM-YYYY")) : 'Today'} Total Recharge`}
              </p>
              <button className="recharge_button1 w-100 f3 fs-xs-14 fs-sm-10 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14 ">
                ₹ {totalRecharge}
              </button>
            </div>
          </div>

          <div className="announcement_date mb-3 col-md-5">
            <DateRange2 selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
          </div>
          <div className="form-group col-md-5 text-start my-3">
            <div className="d-flex ac-js">
              <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
                Search</label>
            </div>
            <div className="login-input1 mt-1">
              <input
                value={mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 14) {
                    setMobile(value);
                  }
                }}
                type="tel"
                placeholder="Search Mobile No & Trans ID"
                required
                maxLength={14}
                className="placholdercolorchanges2"
              />

              {/* <img src={call} alt="call icon" style={{ marginRight: 12, width: 18, top: -1, position: 'relative' }} /> */}
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>

          <div className="col-md-5 my-3">
            <button onClick={handleSearch} className="add-button f3 w-100 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">

              {(loading && searchLoad) ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                />
              ) : (
                <>
                  Search
                </>
              )}
            </button>
          </div>

          <CustomTable
            columns={columns}
            pageno={page}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={true}
            loading={loading}
          />
        </div>
        {popup && (
          <div className="img-popup-design1">
            <div className="img-popup1">
              <button className="close-btn" onClick={() => setPopup(false)}>
                ×
              </button>

              <textarea
                className="input-box3"
                name="reason"
                placeholder="Type your reason here..."
                value={block_reason}
                onChange={(e) => setBlock_reason(e.target.value)}
                rows="4"
              />

              <div className="d-flex ac-jc px-1 py-1">
                <button
                  disabled={!block_reason}
                  onClick={() => handleBlock('Blocked')}
                  className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 w-100 "
                >
                  {loader ? <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white" }}
                    ></span>
                  </> : 'Block User'}
                </button>
              </div>
            </div>
          </div>
        )}
        {deletePopup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure, you want to delete?
              </p>
              <div className="d-flex ac-jb px-2 mt-4 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => setDeletePopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleDelete}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1 ? <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 6 }}
                    ></span>
                  </> : "Yes"}
                </button>
              </div>
            </div>
          </div>
        )}
        {/* {loading && <Loader />} */}
        {popup2 && (
          <div className="img-popup-design">
            <div className="img-popup">
              {showMessage ? (
                <>
                  <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                    Approved By
                  </p>
                  <p className="f4 fs-xs-16 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                    {showMessage}
                  </p>
                </>) : (
                <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                  Not Approved
                </p>
              )}
              <div style={{ paddingTop: 20 }} className="d-flex ac-je px-2 f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button
                  onClick={() => {
                    setShowMessage('');
                    setPopup2(false);
                  }}
                  className="yes-btn w-40"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default RechargeHistory;
